import { FiAlertCircle } from "react-icons/fi";

import { cn } from "utils/helpers";
import type { QuoteTableColumn, ColumnHeader } from "./quote-table.types";

export interface QuoteTableHeaderProps {
	columns: QuoteTableColumn[];
	duplicateColumnNames: Set<string>;
	headers: ColumnHeader[];
	showActionsColumn: boolean;
	showZeroColumn?: boolean;
}

const QuoteTableHeader: React.FC<QuoteTableHeaderProps> = ({
	columns,
	duplicateColumnNames,
	headers,
	showActionsColumn,
	showZeroColumn = false,
}) => {
	return (
		<thead className="h-[44px] bg-[#F9FAFB]">
			<tr className="border-b border-[#EAECF0]">
				{showZeroColumn && (
					<th
						className="bg-[#F9FAFB] font-roboto text-[12px] font-medium text-tertiary-600 w-[3%]"
					>
					</th>
				)}
				{headers.map((th, index) => {
					return (
						<th
							key={th.key}
							className={cn(
								"bg-[#F9FAFB] font-roboto text-[12px] font-medium text-tertiary-600",
								th.key === "idx" ? "text-center" : "text-left",
								index === 0 ? "text-center" : "text-left"
							)}
							style={{ width: th.width }}
						>
							<div
								className={cn(
									th.key === "idx" ? "ml-0" : "md:ml-1 lg:ml-1",
									"mt-[3px] flex items-center gap-1"
								)}
							>
								<span
									className={cn(
										th.columnId && duplicateColumnNames.has(
											(columns.find((c) => c.id === th.columnId)?.label ?? "").toLowerCase()
										) ? "text-amber-600" : ""
									)}
									title={
										th.columnId && duplicateColumnNames.has(
											(columns.find((c) => c.id === th.columnId)?.label ?? "").toLowerCase()
										) ? "Duplicate column name" : undefined
									}
								>
									{th.label}
									{th.columnId && th.isFirstOfGroup && duplicateColumnNames.has(
										(columns.find((c) => c.id === th.columnId)?.label ?? "").toLowerCase()
									) && (
											<FiAlertCircle className="ml-0.5 inline text-amber-500" size={10} />
										)}
								</span>
							</div>
						</th>
					);
				})}
				{showActionsColumn && (
					<th
						className="bg-[#F9FAFB] font-roboto text-[12px] font-medium text-tertiary-600"
						style={{ width: "40px" }}
					>
						<span className="sr-only">Actions</span>
					</th>
				)}
			</tr>
		</thead>
	);
};

export { QuoteTableHeader };
